import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService, OAuthSuccessEvent } from 'angular-oauth2-oidc';
import { Subscription } from 'rxjs';
@Component({
    selector: 'autologin',
    template: ''
})
export class AutoLoginComponent implements OnInit,OnDestroy {
    private subs: Subscription;

    constructor(public oauthService: OAuthService, private router: Router) {
       
    }

    ngOnInit(): void {
         if (this.oauthService.discoveryDocumentLoaded) {
            this.login();
        } else {
            this.subs = this.oauthService.events.subscribe(event => {
                if (event instanceof OAuthSuccessEvent) {
                    if (event.type === 'discovery_document_loaded')
                        this.login();
                }
            });
        }
    }

    login() {
    this.oauthService.initLoginFlow();
       this.oauthService.setupAutomaticSilentRefresh();
        if (!this.oauthService.hasValidAccessToken()) {
            this.oauthService.tryLogin().then(()=> {
            this.router.navigate(['/signin-oidc'])
        });
        } else {
           // this.router.navigate(['/connected'])
        }
        
    }

    ngOnDestroy(): void {
        if (this.subs)
        this.subs.unsubscribe();
    }
}
